<template>
    <div class="voltage-rise-calculator__add" :class="{'is-not-active' : limitReached}">
        <button @click="add">
            <svg v-if="!limitReached" class="icon">
                <use xlink:href="#plus-outline" />
            </svg>
            <svg v-else class="icon">
                <use xlink:href="#plus-outline-disabled" />
            </svg>
            <span class="small semi" :class="{'text--grey-light' : limitReached, 'text--orange' : !limitReached}">{{ text }}</span>
        </button>
        <span class="small semi text--grey-light">{{ added }}/3</span>
    </div>
</template>
<script>
export default {
    props:{
        text: {
            type: String,
            required: true,
        },
        added: {
            type: Number,
            required: true,
        }
    },
    computed: {
        limitReached() {
            return this.added === 3;
        }
    },
    methods: {
        add() {
            this.$emit('add');
        },
    },
};
</script>
